import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  private url = environment.api; 

  constructor(private http: HttpClient) { }

  sendLoginUser(data: any) {
    return this.http.post(this.url+"api/user/login",data);
  }

  getRoleUser() {
    return this.http.get(this.url+"api/role/user");
  }
}
